module.exports = __webpack_public_path__ + "img/new4-img3.59e52fb6.png";